import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64478c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anmly-side-bar-container" }
const _hoisted_2 = { class: "anmly-side-bar-header" }
const _hoisted_3 = { class: "anmly-side-bar-header-text" }
const _hoisted_4 = {
  key: 1,
  class: "anmly-side-bar-no-data-box"
}
const _hoisted_5 = { class: "anmly-side-bar-no-data-icon" }
const _hoisted_6 = { class: "anmly-side-bar-no-anmly-text" }

import RexMenuV3 from '@/rex-components/RexMenuV3.vue';
import AnomalySideBarActions from '@/components/charts/utils/AnomalySideBarActions.vue';
import {
  AnomalyDataObjectType,
  GraphDataNamesEnum,
} from '@/components/Common/graph.types';
import { generateAnomalyMenuList } from '@/components/charts/utils/utils.config';
import { watch, ref, onMounted, Ref, computed } from 'vue';
import { cloneDeep, isEqual } from 'lodash';
interface Props {
  selectedItems: string[];
  anomalyList: AnomalyDataObjectType[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnomalySideBar',
  props: {
    selectedItems: {},
    anomalyList: {}
  },
  emits: ['onSelect'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const isSortAsc: Ref<null | boolean> = ref(null);
const anomalyMenuList: Ref<AnomalyDataObjectType[]> = ref([]);
const selectedFilters: Ref<string[]> = ref([
  GraphDataNamesEnum.CRITICAL_BREACH,
  GraphDataNamesEnum.MAJOR_BREACH,
  GraphDataNamesEnum.MINOR_BREACH,
]);
watch(
  () => props.anomalyList,
  (newVal, oldVal) => {
    if (!isEqual(newVal, oldVal)) {
      anomalyMenuList.value = generateAnomalyMenuList(props.anomalyList);
    }
  },
);

onMounted(() => {
  anomalyMenuList.value = generateAnomalyMenuList(props.anomalyList);
});

function onAnomalySelect(obj) {
  const type = obj?.item?.originItemValue?.label?.props?.type;
  emit('onSelect', obj.selectedKeys, { ...obj?.item?.originItemValue, type });
}

function onSortChange(isAsc) {
  isSortAsc.value = isAsc;
}

function onFilterChange(selectedList) {
  selectedFilters.value = selectedList;
}

const getAnomaliesList = computed(() => {
  const tempMenuList = cloneDeep(anomalyMenuList.value);

  if (isSortAsc.value == true || isSortAsc.value == false) {
    tempMenuList.sort((a, b) =>
      isSortAsc.value
        ? new Date(a?.date || '').getTime() - new Date(b?.date || '').getTime()
        : new Date(b?.date || '').getTime() - new Date(a?.date || '').getTime(),
    );
  }

  return tempMenuList.filter(
    (obj) => selectedFilters.value.indexOf(obj?.sevKey || '') >= 0,
  );
});

return (_ctx: any,_cache: any) => {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('anomalies')), 1),
      _createVNode(AnomalySideBarActions, {
        onOnAnomalySort: onSortChange,
        onOnAnomalyFilter: onFilterChange,
        selectedFilters: selectedFilters.value
      }, null, 8, ["selectedFilters"])
    ]),
    (anomalyMenuList.value?.length > 0)
      ? (_openBlock(), _createBlock(RexMenuV3, {
          key: 0,
          id: "anomaly-side-bar",
          items: getAnomaliesList.value,
          onOnSelect: onAnomalySelect,
          selectedKeys: _ctx.selectedItems,
          class: "anmly-modal-side-menu"
        }, null, 8, ["items", "selectedKeys"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_BaseIcon, { name: "noData" })
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('noAnomaliesFound')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('anomaliesNotFoundThisTimeAndChangeDate')), 1)
        ]))
  ]))
}
}

})